import { Box } from '@mui/material';
import { Bar } from 'react-chartjs-2';
import { Card } from '../../../../components/cards';
import { options, backgrounds } from './chart.options';

export const WeeklyActualVsForecast = ({
  weeklyActualRevenueByServiceCode,
  weeklyForecastRevenueByServiceCode
}) => {
  const labels = [
    ...Object.keys(weeklyActualRevenueByServiceCode).map(
      (item) => `Actual ${item}`
    ),
    ...Object.keys(weeklyForecastRevenueByServiceCode).map(
      (item) => `Forecast ${item}`
    )
  ];

  const combined = {};

  Object.keys(weeklyActualRevenueByServiceCode).forEach((key: string) => {
    weeklyActualRevenueByServiceCode[key].forEach((item) => {
      if (!combined[item.code]) {
        combined[item.code] = {
          [key]: []
        };
      }
      if (!combined[item.code][key]) {
        combined[item.code][key] = [];
      }
      combined[item.code][key].push({
        actual: item.value,
        forecast: weeklyForecastRevenueByServiceCode[key].find(
          (subItem) => item.code === subItem.code
        ).value
      });
    });
  });

  const datasets = [];

  Object.keys(combined).forEach((key, index) => {
    const dataset = {
      categoryPercentage: 0.3,
      label: key,
      data: [],
      fill: false,
      backgroundColor: backgrounds[index]
    };
    Object.keys(combined[key]).forEach((week) => {
      dataset.data.push(
        ...combined[key][week].map((item) => item.actual),
        ...combined[key][week].map((item) => item.forecast)
      );
    });
    datasets.push(dataset);
  });

  const data = {
    labels,
    datasets
  };

  return (
    <Card height={617} title="$ Weekly Actual vs Forecast">
      <Box sx={{ width: '100%', height: 464 }}>
        <Bar
          options={options}
          data={data}
          style={{ maxHeight: 464, width: '100%' }}
        />
      </Box>
    </Card>
  );
};
